import React, { useState } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-area">
          <img src={`${process.env.PUBLIC_URL}/logo-header.png`} alt="Get Morganized LLC logo" className="logo-img prominent" width="210" height="210" decoding="async" fetchPriority="high" />
          <span className="navbar-title">GET MORGANIZED LLC</span>
        </div>
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a></li>
            <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About</a></li>
            <li><a href="#reviews" onClick={() => setIsMenuOpen(false)}>Reviews</a></li>
            <li><a href="#instagram" onClick={() => setIsMenuOpen(false)}>Social</a></li>
            <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
          </ul>
        </nav>
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header; 